import { useEffect } from 'react';

import { Card, CardSection } from '@zillow/constellation';
import { zillowWebLogin } from '@zillow/auth-core';

type Props = { redirectUrl?: string };

const redirectsToAuth0Login = (redirectUrl: string) => {
  zillowWebLogin({
    loginMode: 'redirect',
    trackingConfig: {
      entryPoint: 'rental-manager-login',
    },
    oauthOptions: {
      loginHint: undefined,
    },
    uiConfig: {},
    ...{ redirectUri: redirectUrl },
  });
};

const ZillowWebLogin = ({ redirectUrl = '/rental-manager/properties' }: Props) => {
  useEffect(() => {
    redirectsToAuth0Login(redirectUrl);
  }, [redirectUrl]);

  return (
    <Card data-testid="ZillowWebLogin" cardType="secondary" cardElevation={0} style={{ margin: 'auto' }}>
      <CardSection>Redirecting to auth0...</CardSection>
    </Card>
  );
};

export default ZillowWebLogin;
